import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router's client-side navigation never resets scroll position on its
// own — the window stays exactly where it was on the previous page, so
// navigating away from partway down a page lands you at that same scroll
// offset on the new one instead of at the top. This is the standard fix:
// reset to (0, 0) on every route change, unless the URL includes a hash (in
// which case the in-page section-jump logic in useSectionNavigation.js /
// useElectiveDetail.js already handles positioning and should win instead).
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
